import Home from './Home.data-manager-os.vue'

export default {
  Home
}